import { render, staticRenderFns } from "./couponEdit.vue?vue&type=template&id=11eeb4ba&scoped=true&"
import script from "./couponEdit.vue?vue&type=script&lang=js&"
export * from "./couponEdit.vue?vue&type=script&lang=js&"
import style0 from "./couponEdit.vue?vue&type=style&index=0&id=11eeb4ba&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11eeb4ba",
  null
  
)

export default component.exports